import * as React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import * as Api from 'src/api';
import ContentForm from 'src/components/Content/form';

class ContentEditContainer extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      contentId: this.props.match.params.id,
      contentsSubtypes: [],
      loading: true,
      content: {
        title: null,
        type: 'SPECIALS',
        destination: {},
        body: null,
        longDescription: null,
        meta: {
          title: null,
          keywords: null,
          description: null,
          canonical: null,
        },
        banner: null,
        icon: null,
        active: true,
        search: null,
        foreigners: false,
        tags: [],
      },
    };

    this.onSubmit = this.onSubmit.bind(this);
  }

  public async onSubmit(body: any): Promise<void> {
    await Api.updateContent(this.state.contentId, body);

    toast.success('El registro fue actualizado con éxito');
    return this.props.history.push('/');
  }

  public render() {
    return (
      <ContentForm
        contentId={this.state.contentId}
        content={this.state.content}
        onSubmit={this.onSubmit}
        loading={this.state.loading}
        contentsSubtypes={this.state.contentsSubtypes}
        tags={this.props.tags}
      />
    );
  }

  public async componentWillMount() {
    const [one, two] = await Promise.all([
      Api.listContentSubtypes({ limit: 100, order: 'name ASC' }),
      Api.getContent(this.state.contentId),
    ]);

    this.setState({
      contentsSubtypes: one.data,
      content: two.data,
      loading: false,
    });
  }
}

const mapStateToProps = (state: any) => ({ tags: state.tags });

export default connect(mapStateToProps)(ContentEditContainer);



// WEBPACK FOOTER //
// ./src/containers/Content/edit.tsx